(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-cuts-box-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cuts-box-builder')) {
    customElements.define(
      'cuts-box-builder',
      class CutsBoxBuilder extends HTMLElement {
        connectedCallback() {
          this.selects = [...this.querySelectorAll('[data-cuts-side]')];
          this.progressSteps = [...this.querySelectorAll('[data-progress-step]')];
          this.total = this.querySelector('[data-cuts-total]');
          this.status = this.querySelector('[data-cuts-status]');
          this.button = this.querySelector('[data-cuts-add]');
          this.buttonLabel = this.querySelector('[data-cuts-button-label]');
          this.error = this.querySelector('[data-cuts-error]');
          if (!this.button || this.selects.length === 0) return;
          this.selects.forEach((select) => select.addEventListener('change', () => this.update()));
          this.button.addEventListener('click', () => this.addToCart());
          this.update();
        }

        get selections() {
          return this.selects
            .map((select) => {
              const option = select.selectedOptions[0];
              if (!select.value || !option) return null;
              return {
                id: Number(select.value),
                price: Number(option.dataset.price || 0),
                title: option.dataset.title || option.textContent.trim(),
                side: select.dataset.sideNumber,
              };
            })
            .filter(Boolean);
        }

        update() {
          const selections = this.selections;
          const complete = selections.length === this.selects.length;
          const price = selections.reduce((sum, selection) => sum + selection.price, Number(this.dataset.parentPrice || 0));
          this.total.textContent = this.formatMoney(price);
          this.status.textContent = complete ? this.dataset.readyLabel : this.dataset.chooseLabel;
          this.button.disabled = !complete;
          this.buttonLabel.textContent = complete
            ? `${this.dataset.addLabel} · ${this.formatMoney(price)}`
            : this.dataset.addLabel;
          this.progressSteps.forEach((step, index) => step.classList.toggle('is-complete', index < selections.length));
          this.error.hidden = true;
        }

        formatMoney(cents) {
          const format = this.dataset.moneyFormat || ':amount';
          const amount = (Number(cents || 0) / 100).toFixed(2);
          const amountNoDecimals = Math.round(Number(cents || 0) / 100).toString();
          return format
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
            .replace(/\{\{\s*amount\s*\}\}/g, amount)
            .replace(':amount', amount);
        }

        async addToCart() {
          const selections = this.selections;
          if (selections.length !== this.selects.length || this.button.disabled) return;

          const parentId = Number(this.dataset.parentVariantId);
          const bundleId = globalThis.crypto?.randomUUID?.() || `cuts-${Date.now()}-${Math.random().toString(16).slice(2)}`;
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const items = [
            {
              id: parentId,
              quantity: 1,
              properties: {
                [this.dataset.sizeProperty]: this.dataset.sizeValue,
                [this.dataset.selectionsProperty]: selections.map((selection) => selection.title).join(' · '),
                _custom_cuts_box: 'true',
                _custom_cuts_box_id: bundleId,
              },
            },
            ...selections.map((selection) => ({
              id: selection.id,
              quantity: 1,
              parent_id: parentId,
              properties: {
                [`${this.dataset.sideProperty} ${selection.side}`]: selection.title,
                _custom_cuts_box_component: 'true',
                _custom_cuts_box_id: bundleId,
              },
            })),
          ];

          const payload = { items };
          if (cart?.getSectionsToRender) {
            payload.sections = cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            cart.setActiveElement?.(this.button);
          }

          this.button.disabled = true;
          this.button.setAttribute('aria-busy', 'true');
          this.buttonLabel.textContent = this.dataset.addingLabel;
          this.error.hidden = true;

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(payload),
            });
            const responseText = await response.text();
            let data = null;
            try {
              data = JSON.parse(responseText);
            } catch (parseError) {
              data = null;
            }
            if (!response.ok || !data || data.status) {
              throw new Error(data?.description || data?.message || this.dataset.errorLabel);
            }

            this.buttonLabel.textContent = this.dataset.addedLabel;
            if (cart?.renderContents && data.sections) {
              cart.classList.remove('is-empty');
              cart.renderContents(data);
            } else {
              window.location.assign(this.dataset.cartUrl);
            }
            window.setTimeout(() => this.update(), 900);
          } catch (error) {
            this.update();
            this.error.textContent = error.message || this.dataset.errorLabel;
            this.error.hidden = false;
          } finally {
            this.button.removeAttribute('aria-busy');
            this.button.disabled = this.selections.length !== this.selects.length;
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ripe-delivery-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ripe-delivery-checker')) {
    customElements.define(
      'ripe-delivery-checker',
      class RipeDeliveryChecker extends HTMLElement {
        connectedCallback() {
          this.select = this.querySelector('[data-ripe-delivery-select]');
          this.result = this.querySelector('[data-ripe-delivery-result]');
          if (!this.select || !this.result) return;
          this.select.addEventListener('change', () => this.update());
        }

        update() {
          const option = this.select.options[this.select.selectedIndex];
          const message = option?.dataset.message;
          this.result.hidden = !message;
          this.result.textContent = message || '';
          this.result.classList.toggle('is-outside', option?.value === 'outside');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
